// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"62df69d9580af3f78752d819fec67abdd428399b"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import {extraErrorDataIntegration, replayIntegration} from '@sentry/nextjs';
import * as Sentry from '@sentry/nextjs';
import {denyUrls, ignoreErrors, isDev, SENTRY_DNS, SENTRY_ENABLED, SENTRY_RELEASE} from 'config';

Sentry.init({
  dsn: SENTRY_DNS,
  debug: isDev,
  release: SENTRY_RELEASE,
  enabled: SENTRY_ENABLED,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  // tracesSampleRate: 0.1,
  // tracePropagationTargets: ['localhost', /^https:\/\/straus\.md/],

  // @see - https://docs.sentry.io/platforms/javascript/guides/nextjs/session-replay
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.0,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    extraErrorDataIntegration({depth: 6}),
    replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: true,
      maskAllInputs: false,
      networkDetailAllowUrls: [/^https:\/\/api\.straus\.md/],
      networkCaptureBodies: true,
    }),
  ],
  ignoreErrors: ignoreErrors,
  denyUrls: denyUrls,
  normalizeDepth: 5,
  maxBreadcrumbs: 80,
});
